import React, { useContext } from 'react';
import { ChainClient, IHostName } from '../../../services/WebApiClient';
import { LoginContext } from '../../EditorCommon/LoginContext';
import { SortBy } from '../../Table/SortBy';
import { IColumn, Table } from '../../Table/Table';

export function HostNameTable(props: {
    hostnames: IHostName[],
    onHostnameDeleted: (hn: IHostName) => void
}) {

    const loginContext = useContext(LoginContext);

    async function deleteHost(hn: IHostName) {
        const isSure = window.confirm(`Are you sure you want to delete the hostname '${hn.host}'`);
        if (!isSure)
            return;
        const client = new ChainClient(undefined, loginContext.loginService.http);
        await client.deleteHostname(hn.id);
        props.onHostnameDeleted(hn);
    }

    const columns: IColumn<IHostName>[] = [
        {
            content: hn => hn.host,
            key: "host",
            header: "Host",
            sort: SortBy.String(hn => hn.host)
        },
        {
            content: hn => (
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => deleteHost(hn)}
                >
                    Delete
                </button>
            ),
            key: "delete"
        }
    ]

    return (
        <Table columns={columns}
            rows={props.hostnames}
            rowKey={hn => hn.id}
        />
    );
}
